/**
 * 申请页选购区纯函数：申请数量归一化与总价计算。
 * 抽成纯函数是为了脱离组件直接跑 Node 断言。
 */

/** 申请数量归一化：输入非法（空 / 0 / 负数 / 小数 / 非数字）时兜底为 1（数量输入框失焦时的规则） */
export function normalizeQuantity(val) {
  if (val === '' || val === null || val === undefined) return 1
  const n = Number(val)
  if (!Number.isFinite(n) || n < 1 || Math.floor(n) !== n) return 1
  return n
}

/** 金额按「分」做整数运算，避免 0.01 × 94 = 0.9400000000000001 这类二进制浮点误差 */
const CENTS_PER_YUAN = 100

/** 元转分：先四舍五入到分，后续乘法全程用整数 */
function yuanToCents(value) {
  return Math.round(Number(value || 0) * CENTS_PER_YUAN)
}

/**
 * 总价 = 选中档 price × 数量 + (需要加急 ? 当前档 urgentFee : 0)
 * ⚠️ 加急费是**整单一次性费用**，不乘数量（接口文档 §4.4：总价 = 档位单价 × 数量 + 加急费）。
 * @param {{ price: number, urgentFee?: number }} yearItem 选中年限档
 * @param {number|string} quantity 申请数量
 * @param {number|boolean} isUrgent 1/true = 加急
 */
export function calcTotalPrice(yearItem, quantity, isUrgent) {
  const n = normalizeQuantity(quantity)
  if (!yearItem) return 0
  const baseCents = yuanToCents(yearItem.price) * n
  const urgentCents = isUrgent ? yuanToCents(yearItem.urgentFee) : 0
  return (baseCents + urgentCents) / CENTS_PER_YUAN
}
